import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import { walkingFarmAvailableLeadStatuses } from '../../../../../constants/walking-farm.constant';
import * as fromOrganizationSelectors from '../../../../../store/selectors/organization.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-walking-farm-view-help',
  standalone: false,
  templateUrl: './help.component.html'
})
export class HelpPageComponent {
  private activatedRoute = inject(ActivatedRoute);
  private store = inject(Store);

  organizationFarmAlertsEnabled$: Observable<boolean>;

  defaultBackHref: string | undefined;
  defaultHref: string;

  constructor() {
    const walkingFarmId = this.activatedRoute.snapshot.paramMap.get('id');

    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'];
    this.defaultHref = [this.defaultBackHref ?? '', 'walking-farm', walkingFarmId, 'view'].join('/');

    this.organizationFarmAlertsEnabled$ = this.store.pipe(select(fromOrganizationSelectors.selectFarmAlertsEnabled));
  }

  protected readonly walkingFarmAvailableLeadStatuses = walkingFarmAvailableLeadStatuses;
}
